import TreeItem from './src/tree-item.vue'
import Tree from './src/tree.vue'
import { SFCWithInstall, withInstall } from '@touchvue/utils'

export const ToTree: SFCWithInstall<typeof Tree> = withInstall(Tree)

export const ToTreeItem: SFCWithInstall<typeof TreeItem> = withInstall(TreeItem)

export * from './src/instance'
